module.exports = __webpack_public_path__ + "img/zhang.1e5522ad.png";